module.exports = __webpack_public_path__ + "img/98da8a7.png";